<template>
  <div class="row mb-4">
    <div class="card rounded-3 shadow-sm rounded">
      <div class="card-header bg-white border-bottom-0 text-secondary py-1">
        <div class="row mx-auto">
          <div class="col"></div>
          <h4 class="mb-0">{{ tableContentDisplayerTitle }}</h4>
          <div class="col"></div>
          <h4 class="icon icon-4G-Cam-Inbox80 align-right mr-2 my-auto d-none" v-on:click="downloadTableContentAsJson()"></h4>
        </div>
      </div>
      <div class="card-body pt-1">
        <div v-if="tableMatrixToDisplay !== undefined" class="table-responsive table-xs pb-0 pr-2" :style="{'max-height': tablesHeight, 'max-width': '90vw'}">

          <table class="table mb-0" :class="{'headerAlwaysVisible': displayHeaderLineAsFirstLine}">
            <tr class="pb-0 mb-0 border-bottom-0" v-for="(line,i) in tableMatrixToDisplay.getRows().filter((lineToDisplay, lineIndex) => displayHeaderLineAsFirstLine && (isHeaderLine(lineIndex) || isHeaderPositionWithoutHeaderLine(lineIndex)))" :key="'tr-header-'+i">
              <th class="pl-0 pr-0 pb-0" v-for="(element,index) in line" :key="'th-'+index" :class="{'d-none': isHiddenByFilterElement(line, i, index, true)}">
                <div class="d-flex shadow-sm" :style="{'min-height': thHeaderDivMinHeight+'px'}">
                  <div class="d-flex flex-fill justify-content-center" ref="th_header_div" @mouseover="onMouseOverHeader(index)" @mouseleave="onMouseLeaveHeader(index)">
                    <div class="d-flex flex-column my-auto">
                      <b v-if="hasHeader">{{ element }}</b>
                      <small v-if="!hasHeader">{{ $t('empty-header') }}</small>
                    </div>
                  </div>
                </div>
                <!--
                <div class="spacer bg-white pt-2" :style="{'color': 'white', 'background-color': 'white !important'}">
                </div>
                -->
              </th>
            </tr>
            <tr v-if="displayHeaderLineAsFirstLine" class="spacer">
              <td></td>
            </tr>
            <tr class="shadow-sm" v-for="(line,i) in tableMatrixToDisplay.getRows()" :key="'tr-'+i">
              <th class="" v-for="(element,index) in line" :key="'th-'+index" :class="{'d-none': !repeatHeaderInArrayContent || !isHeaderLine(i) || !displayHeaderLineAsFirstLine || isHiddenByFilterElement(line, i, index)}">

                <div v-if="showTableContentAsHtml" v-html="element"></div>
                <div v-if="showTableContentAsText">{{ element }}</div>

              </th>
              <td class="border" v-for="(element,index) in line" :key="'td-'+index" :class="{'border-300': !isHeaderLine(i), 'border-600': isHeaderLine(i), 'custom-small-border-top': isHeaderLine(i), 'd-none': isHiddenByFilterElement(line, i, index) || (isHeaderLine(i) && displayHeaderLineAsFirstLine), 'hoverElement': isHoverElement(line, i, index)}">

                <div v-if="showTableContentAsHtml" v-html="element" @mouseover="onMouseOver(line, i, index)" @mouseleave="onMouseLeave(line, i, index)"></div>
                <div v-if="showTableContentAsText" @mouseover="onMouseOver(line, i, index)" @mouseleave="onMouseLeave(line, i, index)">{{ element }}</div>

              </td>
            </tr>
          </table>

        </div>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: "TableContentDisplayer",
  components: {
  },
  props: ["tableContentDisplayerTitle", "tableMatrixToDisplay", "orientation", "hasHeader", "headerPosition", "repeatHeaderInArrayContent", "maxHeight", "hoverCoordinates", "isCEA", "isCTA", "isCPA", "filterCoordinates"],
  data() {
    return {
      displayHeaderLineAsFirstLine: true,
      mouseHoverLine: undefined,
      resetFilterOnSameFilterActivated: true,
      thHeaderDivMinHeight: 0
    }
  },
  mounted() {
    this.updateThHeaderDivMinHeight();
  },
  updated() {
    this.updateThHeaderDivMinHeight();
  },
  computed: {
    tablesHeight: function() {
      if (this.maxHeight === undefined) {
        return '350px';
      } else {
        return this.maxHeight;
      }
    },
    showTableContentAsHtml: function() {
      return ((this.isCTA) || (this.isCPA) || (this.isCEA));
    },
    showTableContentAsText: function() {
      return (!this.showTableContentAsHtml);
    },
  },
  methods: {
    updateThHeaderDivMinHeight: function() {
      if (this.$refs.th_header_div !== undefined) {
        const thHeaderDivMinHeightCalculated = this.$refs.th_header_div.map((elem) => {
          return elem.getBoundingClientRect().width > 0 ? elem.getBoundingClientRect().height : 0
        }).reduce((previousValue, currentValue) => {
          return (previousValue > currentValue) ? previousValue : currentValue;
        }, 0);
        if (thHeaderDivMinHeightCalculated !== this.thHeaderDivMinHeight) {
          this.thHeaderDivMinHeight = thHeaderDivMinHeightCalculated;
        }
      }
    },
    isHover: function(objectCoordinates) {
      if (this.hoverCoordinates !== undefined) {

        if (this.isCEA) {

          if (this.hoverCoordinates.row === undefined) {
              const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId);
              return returnedValue;
          } else {
              const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId) && [this.hoverCoordinates.row].includes(objectCoordinates.rowId);
              return returnedValue;
          }

        } else if (this.isCTA) {

          const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId);
          return returnedValue;

        } else if (this.isCPA) {

          if (this.hoverCoordinates.columnLinked === undefined) {
              // const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId);
              const returnedValue = [this.hoverCoordinates.column].includes(objectCoordinates.columnId) || [this.hoverCoordinates.column].includes(objectCoordinates.columnLinked);
              return returnedValue;
          } else {
              // const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId) && [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnLinked);
              const returnedValue = [this.hoverCoordinates.column].includes(objectCoordinates.columnId) && [this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnLinked);
              return returnedValue;
          }

        } else {

          if ((objectCoordinates.rowId === undefined)) {
            // isHover test for column of table content
            if (this.hoverCoordinates.row === undefined) {
              const returnedValue = [this.hoverCoordinates.column, this.hoverCoordinates.columnLinked].includes(objectCoordinates.columnId);
              return returnedValue;
            } else {
              return false;
            }
          } else {
            const returnedValue = [this.hoverCoordinates.column].includes(objectCoordinates.columnId) && [this.hoverCoordinates.row].includes(objectCoordinates.rowId);
            return returnedValue;
          }

        } 
      } else {
        return false;
      }
      
    },
    isHoverElement: function(line, lineIndex, columnIndex) {
      if (this.isCEA === true) {
        return this.isHover({'columnId': line[1], 'rowId': line[0]});
      } else if (this.isCTA === true) {
        return this.isHover({'columnId': line[0]});
      } else if (this.isCPA === true) {
        // return this.isHover({'columnId': line[0]}) || this.isHover({'columnId': line[1]});
        // to add hoverElement class for the 2 columns but only for the 'columnId'-'columnLinked' couple on CPA
        // return this.isHover({'columnId': line[0], 'columnLinked': line[1]}) || this.isHover({'columnId': line[1], 'columnLinked': -1});
        return this.isHover({'columnId': line[0], 'columnLinked': line[1]});
      } else {
        return this.isHover({'columnId': columnIndex}) || this.isHover({'columnId': columnIndex, 'rowId': lineIndex});
      }      
    },
    onMouseOver: function(line, lineIndex, columnIndex) {
      if (line === this.mouseHoverLine) {
        // do nothing
      } else if (line !== undefined) {
        this.mouseHoverLine = line;
        if (this.isCEA === true) {
          this.$emit('hover-changed', { row: line[0], column: line[1] });
        } else if (this.isCTA === true) {
          this.$emit('hover-changed', { column: line[0] });
        } else if (this.isCPA === true) {
          this.$emit('hover-changed', { column: line[0], columnLinked: line[1] });
        } else {
          this.$emit('hover-changed', { row: lineIndex, column: columnIndex });
        }
      }
    },
    onMouseLeave: function(line) {
      if (line === this.mouseHoverLine) {
        this.mouseHoverLine = undefined;
        this.$emit('hover-changed', undefined);
      } else {
        // do nothing
      }
    },
    onMouseOverHeader: function(columnIndex, columnLinkedIndex) {
      if (columnLinkedIndex === undefined) {
        this.$emit('hover-changed', { column: columnIndex });
      } else {
        this.$emit('hover-changed', { column: columnIndex, columnLinked: columnLinkedIndex });
      }
    },
    onMouseLeaveHeader: function() {
      this.mouseHoverLine = undefined;
      this.$emit('hover-changed', undefined);
    },
    isHiddenByFilterElement: function(line, lineIndex, columnIndex, isHeader) {
      let elementCoordinates;
      if (this.isCEA === true) {
        elementCoordinates = {'columnId': line[1], 'rowId': line[0], 'isHeader': isHeader};
      } else if (this.isCTA === true) {
        elementCoordinates = {'columnId': line[0], 'isHeader': isHeader};
      } else if (this.isCPA === true) {
        elementCoordinates = {'columnId': line[0], 'columnLinked': line[1], 'isHeader': isHeader};
      } else {
        elementCoordinates = {'columnId': columnIndex, 'rowId': lineIndex, 'isHeader': isHeader};
      }
      return this.isCoordinatesHiddenByFilter(elementCoordinates);
    },
    isCoordinatesHiddenByFilter: function(objectCoordinates) {
      if (this.filterCoordinates === undefined) {
        return false;
      } else {
        let returnedIsHiddenByFilter = false;
        if (objectCoordinates.isHeader) {
          if ((!this.isCEA) && (!this.isCTA) && (!this.isCPA) && (this.filterCoordinates.row === undefined)) {
            // The table content is the only table where we can remove some columns in display
            if (this.filterCoordinates.columnLinked !== undefined) {
              returnedIsHiddenByFilter = ![this.filterCoordinates.column, this.filterCoordinates.columnLinked].includes(objectCoordinates.columnId);
            } else {
              returnedIsHiddenByFilter = ![this.filterCoordinates.column].includes(objectCoordinates.columnId);
            }
          }
        } else if (this.filterCoordinates.row !== undefined) {
          if ((!this.isCTA) && (!this.isCPA) && (objectCoordinates.rowId !== undefined)) {
            // filter on row only
            returnedIsHiddenByFilter = ![this.filterCoordinates.row].includes(objectCoordinates.rowId);
          } else if ((this.filterCoordinates.column !== undefined) && (!objectCoordinates.isHeader)) {
            // filter on columns only
            if (this.filterCoordinates.columnLinked !== undefined) {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) && [this.filterCoordinates.columnLinked].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column, this.filterCoordinates.columnLinked].includes(objectCoordinates.columnId);
              }
            } else {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) || [this.filterCoordinates.column].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column].includes(objectCoordinates.columnId);
              }
            }
          }
        } else if (this.filterCoordinates.column !== undefined) {
            // filter on columns only
            if (this.filterCoordinates.columnLinked !== undefined) {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) && [this.filterCoordinates.columnLinked].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column, this.filterCoordinates.columnLinked].includes(objectCoordinates.columnId);
              }
            } else {
              if (this.isCPA) {
                returnedIsHiddenByFilter = !([this.filterCoordinates.column].includes(objectCoordinates.columnId) || [this.filterCoordinates.column].includes(objectCoordinates.columnLinked));
              } else {
                returnedIsHiddenByFilter = ![this.filterCoordinates.column].includes(objectCoordinates.columnId);
              }
            }
          }
        return returnedIsHiddenByFilter;
      }
    },
    /*
    onDoubleClick: function(line, lineIndex) {
      let returnedFilterCoordinates;
      if (this.isCEA === true) {
        // returnedFilterCoordinates = { row: line[0], column: line[1] };
        returnedFilterCoordinates = { row: line[0] };
      } else if (this.isCTA === true) {
        returnedFilterCoordinates = { column: line[0] };
      } else if (this.isCPA === true) {
        returnedFilterCoordinates = { column: line[0], columnLinked: line[1] };
      } else {
        // returnedFilterCoordinates = { row: lineIndex, column: columnIndex };
        returnedFilterCoordinates = { row: lineIndex };
      }

      if (this.filterCoordinates === undefined) {
        console.log("[onDoubleClick] -~~-> filter-changed");
        this.$emit('filter-changed', returnedFilterCoordinates);
      } else if ((returnedFilterCoordinates.row === this.filterCoordinates.row) && (returnedFilterCoordinates.column === this.filterCoordinates.column) && (returnedFilterCoordinates.columnLinked === this.filterCoordinates.columnLinked)) {
        // it's the same filterCoordinates, so remove this filter
        if (this.resetFilterOnSameFilterActivated) {
          console.log("[onDoubleClick] -~~-> filter-changed with undefined value");
          this.$emit('filter-changed', undefined);
        } else {
          // do nothing
        }
      } else {
        console.log("[onDoubleClick] -~~-> filter-changed");
        this.$emit('filter-changed', returnedFilterCoordinates);
      }
    },
    */
    /*
    onDoubleClickHeader: function(columnIndex, columnLinkedIndex) {
      let returnedFilterCoordinates;
      if (columnLinkedIndex === undefined) {
        returnedFilterCoordinates = { column: columnIndex };
      } else {
        returnedFilterCoordinates = { column: columnIndex, columnLinked: columnLinkedIndex };
      }

      if (this.filterCoordinates === undefined) {
        console.log("[onDoubleClickHeader] -~~-> filter-changed");
        this.$emit('filter-changed', returnedFilterCoordinates);
      } else if ((returnedFilterCoordinates.row === this.filterCoordinates.row) && (returnedFilterCoordinates.column === this.filterCoordinates.column) && (returnedFilterCoordinates.columnLinked === this.filterCoordinates.columnLinked)) {
        // it's the same filterCoordinates, so remove this filter
        if (this.resetFilterOnSameFilterActivated) {
          console.log("[onDoubleClickHeader] -~~-> filter-changed with undefined value");
          this.$emit('filter-changed', undefined);
        } else {
          // do nothing
        }
      } else {
        console.log("[onDoubleClickHeader] -~~-> filter-changed");
        this.$emit('filter-changed', returnedFilterCoordinates);
      }
    },
    */
    isHeaderLine: function(index) {
      let result = false;
      if ((this.orientation === 'HORIZONTAL') && (this.hasHeader === true) && (this.headerPosition === index)) {
      // if ((this.orientation === 'HORIZONTAL') && (this.hasHeader === true) && (10 === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    isHeaderPositionWithoutHeaderLine: function(index) {
      let result = false;
      if ((this.hasHeader === false) && (this.headerPosition === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    downloadTableContentAsJson: function() {
      let tableContentAsJsonData = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.tableMatrixToDisplay.getRows(), undefined, 2));
      const downloadHtmlElement = document.createElement('a');
      downloadHtmlElement.setAttribute('href', tableContentAsJsonData);
      downloadHtmlElement.setAttribute('download', this.tableContentDisplayerTitle + '.json');
      document.body.appendChild(downloadHtmlElement);
      downloadHtmlElement.click();
      downloadHtmlElement.remove();
    }

  }

};
</script>
<style scoped>

table.headerAlwaysVisible th {
  z-index: 5;
  position: sticky;
  top: 0px;
  background-color: whitesmoke;
}

.table-xs td, .table-xs th {
  padding: .2625rem .2625rem calc(.2625rem + 1px);
}

.custom-small-border-top {
  border-top-width: 0.156rem !important;
}

.smaller-font-size {
  font-size: smaller;
}

.hoverElement {
  background: lavender;
}

.clickable {
  cursor: pointer
}

</style>